export default "__VITE_ASSET__BlDBYsis__"